import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FEATURES, featurePath } from "../../data/site";
import { FadeUp } from "../site/motion";
import { SectionHead, Container } from "./SectionHead";

const BentoCard = ({ f, big }) => (
  <Link to={featurePath(f.slug)} data-testid={`bento-${f.slug}`} className="group relative block h-full min-h-[320px] overflow-hidden rounded-[1.75rem] border border-cyan-400/20 transition-[border-color,box-shadow] duration-500 hover:border-cyan-300/70 hover:shadow-[0_0_40px_rgba(34,211,238,0.25)]">
    <img src={f.hero} alt={f.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/0" />
    <div className="absolute right-5 top-5 grid h-11 w-11 place-items-center rounded-full border border-white/40 bg-ink/40 backdrop-blur transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-cyan-400 group-hover:text-ink">
      <ArrowUpRight className="h-5 w-5" />
    </div>
    <div className="absolute inset-x-0 bottom-0 p-6 lg:p-7">
      <p className="font-mono text-xs tracking-[0.3em] text-cyan-200">{f.no} / 05</p>
      <div className="mt-3 flex items-center gap-3"><f.icon className="h-6 w-6 text-cyan-200" strokeWidth={1.5} /><h3 className={`font-display font-semibold text-white ${big ? "text-3xl lg:text-4xl" : "text-2xl"}`}>{f.title}</h3></div>
      <p className={`mt-2 text-sm text-slate-200 ${big ? "max-w-md" : "line-clamp-2"}`}>{f.short}</p>
    </div>
  </Link>
);

export const FeatureBento = () => (
  <Container testId="feature-bento">
    <SectionHead eyebrow="02 — Your kitchen companion" title={<>Practical support,<br /><span className="text-grad">personalized to your home.</span></>}
      right={<Link to="/features" data-testid="bento-all-features-btn" className="btn-ghost shrink-0">All features <ArrowUpRight className="h-4 w-4" /></Link>} />
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[320px_320px]">
      {FEATURES.map((f, i) => (
        <FadeUp key={f.slug} delay={i * 0.08} className={i === 0 ? "sm:col-span-2 lg:row-span-2" : ""}>
          <BentoCard f={f} big={i === 0} />
        </FadeUp>
      ))}
    </div>
  </Container>
);
